const customThemeFns = () => {
  // mobile nav
  $(document).on("click", ".nav-label", function(){
    var inputId = $(this).prop("for");
    if ($("#" + inputId).hasClass("open")) {
      $("#" + inputId).removeClass("open");
      setTimeout(function(){
        $("#" + inputId).prop("checked", false);
      }, 100);
    } else {
      $("input[name='mobile-nav']").removeClass("open");
      $("#" + inputId).addClass("open");
    }
  });

  // blog recipes filter

  const filters = document.querySelectorAll('input[name="blog-filter"]');

  filters.forEach(filter => {
    filter.addEventListener('change', function () {
      const url = this.dataset.filter;
      if (url) {
        window.location.href = url;
      }
    });
  });

  const clearBtn = document.querySelector('.nx-filterdrop--clearbtn');
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      const baseUrl = window.location.href.split('/tagged/')[0];
      window.location.href = baseUrl;
    });
  }



  // playing videos on hover
  let hoverVideos = document.querySelectorAll('.autoplay-false');
  hoverVideos.forEach(container => {
    let parent = container.parentElement;
    let video = container.querySelector('video') || container.querySelector('iframe');
    parent.onmouseover = function() {
      video.classList.add('video-playing');
      if (container.querySelector('img')) {
        let img = container.querySelector('img');
        img.classList.add('hide');
      }
      if (video.tagName == 'IFRAME') {
        let host = video.getAttribute('data-host');
        if (host == 'youtube') {
          video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
        } else {
          const player = new Vimeo.Player(video);
          player.play();
        }
      } else {
        video.play();
      }
    };
    parent.onmouseleave = function() {
      video.classList.remove('video-playing');
      if (container.querySelector('img')) {
        let img = container.querySelector('img');
        img.classList.remove('hide');
      }
      if (video.tagName =='IFRAME') {
        let host = video.getAttribute('data-host');
        if (host == 'youtube') {
          video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
        } else {
          const player = new Vimeo.Player(video);
          player.pause();
        }
      } else {
        video.pause();
      }
    };
  });

  // parallax elements
  const parallaxElems = document.querySelectorAll('.background-filler.background--parallax img, .background-filler.background--parallax video');
  if (parallaxElems.length) {
    // perf (homepage only): simpleParallax forces layout on init; start it only when a parallax section nears the viewport
    const initParallax = () => new simpleParallax(parallaxElems, {
      delay: 1.0,
      customWrapper: '.background--parallax'
    });
    if (document.body.classList.contains('template-index') && 'IntersectionObserver' in window) {
      const parallaxObserver = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        parallaxObserver.disconnect();
        initParallax();
      }, { rootMargin: '100% 0px' });
      parallaxElems.forEach(el => parallaxObserver.observe(el.closest('.background--parallax')));
    } else {
      initParallax();
    }
  };

  // sections with custom z-index
  const sectionsWithCustomZIndex = document.querySelectorAll('[data-z-index]');
  if (sectionsWithCustomZIndex) {
    sectionsWithCustomZIndex.forEach(section => {
      let index = section.getAttribute('data-z-index'),
          container = section.closest(".shopify-section[class*='section--']");
      Object.assign(container.style, {
        zIndex: index,
        overflow: "visible"
      });
      section.style.overflow = "visible";
    });
  };

  // open external links in new tab
  var links = document.links;
  for (let i = 0; i < links.length ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
};

document.addEventListener('DOMContentLoaded', function() {
  customThemeFns();
});

document.addEventListener('shopify:section:load', function() {
  customThemeFns();
});


